import { useCallback } from 'react'
import { Box } from '@mui/material'

import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'

import styles from './individual-subscription-notice.module.scss'

export const IndividualSubscriptionNotice = ({ contactEmail = 'help@air.fail' }: { contactEmail?: string }) => {
	const { showMessage } = useShowDataStore()

	const copyEmail = useCallback(async () => {
		try {
			await navigator.clipboard.writeText(contactEmail)
			showMessage('Почта скопирована', 'success')
		} catch {
			showMessage('Не удалось скопировать', 'error')
		}
	}, [contactEmail, showMessage])

	return (
		<Box className={styles.root}>
			<div
				className={styles.decor}
				style={{ backgroundImage: "url('/subscription/svg-icons/decor.png')" }}
			/>
			<Box className={styles.content}>
				<h2 className={styles.title}>У вас указана индивидуальная подписка!</h2>
				<p className={styles.description}>
					По вопросам платежей, тарификации или отключения индивидуальной подписки обращайтесь по адресу —{' '}
					<span className={styles.mail}>
						<button type="button" className={styles.emailCopyBtn} onClick={copyEmail}>
							{contactEmail}
						</button>
						<button
							type="button"
							className={styles.copyIconBtn}
							onClick={copyEmail}
						>
							<img src="/subscription/svg-icons/copy.png" alt="" width={18} height={18} />
						</button>
					</span>
				</p>
				<Box className={styles.actions}>
					<a href={`mailto:${contactEmail}`} className={styles.btn}>
						Написать на почту
					</a>
				</Box>
			</Box>
		</Box>
	)
}
